import React, { useEffect, useState } from 'react';
import { userApi } from '../redux/api/userApi';
import { ticketApi } from '../redux/api/ticketApi';
import { IHomeTicket, ITicketListItem } from '../types/Ticket/Ticket';
import { Button, Card } from '@fluentui/react-components';
import { Link } from 'react-router-dom';
import TicketCard from './TicketCard';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { ListView } from '@progress/kendo-react-listview';
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools';
import ReassignCard from './ReassignCard';

const TicketCardList: React.FC<{ list: ITicketListItem[] }> = ({ list }) => {
    const { data: userProfile } = userApi.useGetProfileQuery();
    //Temp work around while the new API is being built
    //const { data: OGtickets, isLoading: ogLoading } = TicketApi.useGetMyHomeTicketsQuery(undefined);

    const theTickets = list || [];
    const [filter, setFilter] = useState('');
    const [data, setData] = React.useState(theTickets?.slice());
    const isLoading = false;


    const [page, setPage] = React.useState({
        skip: 0,
        take: 20
    });

    const handlePageChange = (e: PageChangeEvent) => {
        setPage({
            skip: e.skip,
            take: e.take
        });
    }

    const { skip, take } = page;
    const renderItem = (props: { dataItem: any; }) => {
        let ticket = props.dataItem;
        return (<TicketCard ticket={ticket} profile={userProfile} />);
    }
    useEffect(() => {
        if (theTickets) {
            setData(filterBy(theTickets?.slice().sort((a, b) => b.Id - a.Id), {
                filters: [
                    { field: 'Call_ID', operator: 'contains', value: filter || '' },
                    { field: 'Company_Name', operator: 'contains', value: filter || '' },
                    { field: 'Contact_Name', operator: 'contains', value: filter || '' },
                    { field: 'Project_Name', operator: 'contains', value: filter || '' },
                    { field: 'Description', operator: 'contains', value: filter || '' },
                ], logic: 'or'
            } as CompositeFilterDescriptor));

            //Reset the page on filter change
            if (filter) {
                setPage((p) => {
                    return {
                        skip: 0,
                        take: p.take
                    }
                });
            }
        }
    }, [filter, theTickets]);

    //const internalUser = !userProfile?.Features.External_Interface;



    return (
        <>
            {theTickets?.length === 0 && !isLoading &&
                <Card className=' no-tickets mt-4 p-3 ms-1 me-1'>
                    <h5>No {userProfile?.Phrases.CallPhrase}s found</h5>
                </Card>}

            <div className='fullscreen'>
                <ListView
                    data={data?.slice(skip, skip + take)}
                    item={renderItem}
                    style={{ width: "100%" }}
                />
            </div>
            {data && <Pager
                responsive={false}
                className=''
                skip={skip}
                take={take}
                onPageChange={handlePageChange}
                total={data?.length}
                buttonCount={5}
            />}
        </>
    );
};

export default TicketCardList;